<template>
  <div class="container">
    <div class="section-title" style="text-align: center; margin-top: 40px;">
      Oferty specjalne
    </div>
    <div class="offer-container" v-if="!specialOffersExpired">
      <!-- <path-navigation
        :paths="[
          {
            name: 'Oferty specjalne',
            to: `/oferty-specjalne/${this.$route.params.id}`,
          },
        ]"
      /> -->

      <section class="card">
        <h2 class="sub-title">{{ offer ? `${offer.name}` : "" }}</h2>

        <div
          class="offers"
          v-if="offer && offer.items && offer.items.length > 0"
        >
          <div class="type-content">
            <div v-for="item in offerItems" :key="item.id">
              <div class="offer">
                <div class="offer-description">
                  <img
                    class="mb-4"
                    style="border-radius: 20px;"
                    :src="getImage(item)"
                  />
                  <p class="name" style="color: #6D6963;">
                    <b>{{ item.name }}</b>
                  </p>
                  <p style="color:#6D6963">{{ item.description }}</p>
                  <div
                    class=""
                    style="display: flex;align-items: center; justify-content: center; margin-top: 30px;"
                  >
                    <rounded-color-button
                      :label="'Oglądaj'"
                      :width="'200px'"
                      :classes="'withLetterSpacing'"
                      @clicked="moveToVideo(item)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h3 class="ml-1">Brak nagrań do wyświetlenia</h3>
        </div>
      </section>
    </div>

    <div class="offers-expired pt-4 text-center" v-if="specialOffersExpired">
      <p>
        Czas dostępu do oferty specjalnej minął. Aby kontynuować praktykę,
        przedłuż swój dostęp, kupując ofertę ponownie.
      </p>

      <rounded-color-button
        :label="'Wykup dostęp'"
        :width="'100%'"
        :classes="'withLetterSpacing'"
        @clicked="moveToBuyOffer"
      />
    </div>
  </div>
</template>

<script>
import { SERVER_URL } from "../axios";
import RoundedColorButton from "../components/buttons/RoundedColorButton.vue";

export default {
  metaInfo: {
    title: "Dagajoga warsztaty - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
      {
        property: "og:image",
        content: "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png",
      },
    ],
  },
  name: "SpecialOffers",
  data: () => ({
    specialOffersExpired: false,
  }),
  components: {
    RoundedColorButton,
  },
  props: {
    path: String,
  },

  async mounted() {
    await this.$store.dispatch(
      "specialOffers/fetchSpecialOffer",
      this.$route.params.id
    );
    const isPaid = await this.$store.dispatch(
      "specialOffers/checkUserPaidForOffer",
      this.$route.params.id
    );

    if (!isPaid) {
      this.redirectLogin();
    } else {
      const isNotExpired = await this.$store.dispatch(
        "specialOffers/checkSpecialOfferIsNotExpired",
        this.$route.params.id
      );

      if (!isNotExpired) {
        this.specialOffersExpired = true;
      }
    }
  },

  computed: {
    offer() {
      return this.$store.getters["specialOffers/getSpecialOffer"];
    },
    offerItems() {
      return this.offer.items;
    },
  },
  methods: {
    moveToBuyOffer() {
      this.$router.push({
        name: "SpecialOfferPayment",
        id: this.$route.params.id,
      });
    },

    redirectLogin(signup) {
      this.$router.push({
        name: "Auth",
        params: { name: "", signup: signup },
      });
    },
    async moveToVideo(item) {
      await this.$store.dispatch("specialOffers/setSpecialOfferItemToNull");
      await this.$store.dispatch(
        "specialOffers/fetchSpecialOfferItem",
        item.id
      );
      this.$router.push({
        name: "SpecialOfferVideo",
        params: {
          id: item.id,
          path: `oferty-specjalne/${this.$route.params.id}`,
        },
      });
    },
    getImage(item) {
      const extension = item.imagePath?.split(".")[1];
      return `${SERVER_URL}${item.id}.${extension}?d=${new Date().getTime()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 2560px;
  margin: 0;
}
.type-content {
  //border: 1px solid rgb(0, 0, 0, 0.25);
  //padding: 1rem;
  //border-radius: 20px;
  //margin-bottom: 3rem;
  //box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.card {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
  margin: 30px auto;
  max-width: 80vw;
  @media (max-width: 1024px) {
    max-width: 95vw;
  }
}

.offer-container {
  h2 {
    font-size: 2.4rem;
    padding-bottom: 1.5rem;
    @media (max-width: 768px) {
      font-size: 2.1rem;
    }
    @media (max-width: 425px) {
      font-size: 1.7rem;
      text-align: center;
      padding-bottom: 1rem;
    }
  }
  p {
    color: #000;
  }
  .path {
    a {
      color: #000;
      text-decoration: none;
      font-weight: 500;
    }
    @media (max-width: 425px) {
      margin-top: -2rem;
      padding-bottom: 20px !important;
    }
  }

  .offer-description {
    p {
      font-size: 1.05rem;
      width: 100%;
      margin-bottom: 1rem;
      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
        text-align: justify;
      }
    }
  }
}

.offers {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.offer {
  display: flex;
  align-content: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.offer-description {
  display: flex;
  flex-direction: column;

  margin-left: 2rem;
  @media (max-width: 425px) {
    text-align: center;
    margin-left: 0;
  }
}
.offer img {
  width: 200px;
  height: 200px;
  border-radius: 0.5rem;
  object-fit: cover;
}
</style>
